<template>
  <div class="additional-data">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4">
        <div
          class="form-group text-left"
          v-for="f in leftFields"
          :key="f.key"
        >
          <label class="control-label">{{ $t(f.label) }}</label>
          <DxNumberBox
            v-model="localData.additional_data[f.key]"
            :min="0"
            :step="f.step || 0.1"
            :showSpinButtons="true"
            :format="numberFormat"
            :useMaskBehavior="true"
            :tabIndex="getTabIndex(f.key)"
          />
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4">
        <div
          class="form-group text-left"
          v-for="f in rightFields"
          :key="f.key"
        >
          <label class="control-label">{{ $t(f.label) }}</label>
          <DxNumberBox
            v-model="localData.additional_data[f.key]"
            :min="0"
            :step="f.step || 0.1"
            :showSpinButtons="true"
            :format="numberFormat"
            :useMaskBehavior="true"
            :tabIndex="getTabIndex(f.key)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DxNumberBox from "devextreme-vue/number-box";
export default {
  name: "additionalData",
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: { 
        ...this.formData,
        additional_data: this.formData?.additional_data || {}
      },
      numberFormat: "#,##0.####",
      fieldDefs: [
        { key: "moisture", label: "scale.weighing_on_scale.moisture", step: 0.1 },
        { key: "foreign_matter", label: "scale.weighing_on_scale.foreign_matter", step: 0.1 },
        { key: "broken_kernels", label: "scale.weighing_on_scale.broken_kernels", step: 0.1 },
        { key: "protein", label: "scale.weighing_on_scale.protein", step: 0.1 },
        { key: "gluten", label: "scale.weighing_on_scale.gluten", step: 0.1 },
        { key: "hectoliter_mass", label: "scale.weighing_on_scale.hectoliter_mass", step: 0.1 },
        { key: "oil_content", label: "scale.weighing_on_scale.oil_content", step: 0.1 },
        { key: "oleic_acidity", label: "scale.weighing_on_scale.oleic_acidity", step: 0.1 },
        { key: "w_value", label: "scale.weighing_on_scale.w_value", step: 0.1 },
        { key: "crude_oils", label: "scale.weighing_on_scale.crude_oils", step: 0.1 },
        { key: "starch_content", label: "scale.weighing_on_scale.starch_content", step: 0.1 },
        { key: "alcohol", label: "scale.weighing_on_scale.alcohol", step: 0.1 },
        { key: "don_toxin", label: "scale.weighing_on_scale.don_toxin", step: 0.1 },
        { key: "alpha_toxin", label: "scale.weighing_on_scale.alpha_toxin", step: 0.1 },
        { key: "sedimentation", label: "scale.weighing_on_scale.sedimentation", step: 0.1 },
      ],
    };
  },

  computed: {
    leftFields() {
      const half = Math.ceil(this.fieldDefs.length / 2);
      return this.fieldDefs.slice(0, half);
    },
    rightFields() {
      const half = Math.ceil(this.fieldDefs.length / 2);
      return this.fieldDefs.slice(half);
    },
  },
  components: {
    DxNumberBox,
  },
  methods: {
    validate() {
      // Validate that additional_data object exists
      if (!this.localData.additional_data) {
        this.localData.additional_data = {};
      }
      return {
        error: false,
        message: "",
      };
    },
    updateData(newData) {
      if (newData && JSON.stringify(this.localData) !== JSON.stringify(newData)) {
        this.localData = { 
          ...newData,
          additional_data: newData?.additional_data || {}
        };
      }
    },
    getTabIndex(key) {
      const idx = this.fieldDefs.findIndex((f) => f.key === key);
      return idx >= 0 ? idx + 1 : 0;
    },
    initFields() {
      this.fieldDefs.forEach((f) => {
        if (typeof this.localData.additional_data[f.key] === "undefined") {
          this.$set(this.localData.additional_data, f.key, null);
        }
      });
    },
  },
  watch: {
    'localData.additional_data': {
      deep: true,
      handler(newData) {
        // Wrap additional_data in the correct structure for parent to merge
        this.$emit("update-form-data", { additional_data: newData }, 4);
      },
    },
  },
  mounted() {
    this.initFields();
  },
};
</script>

<style scoped>
.additional-data {
  height: 100%;
  width: 100%;
}
</style>
